import React from 'react';
import { PropTypes } from 'prop-types';

import Link from '../../../../util/link';
import imageModifier from '../../helpers/imageModifier';
import translateObj from '../../../../util/translateObj';
import { useRoutes } from '../../../../context/routesContext';
import { DEFAULT_PROPS_ITEMS_PER_ROW } from '../../GroupedItems';

const IMAGE_SIZE = '730x520';

const News = ({ image, title, tags, url, itemsPerRowPerMediaQuery, color }) => {
  const { language, path } = useRoutes();

  const [tag] = tags;

  const { mobile } = itemsPerRowPerMediaQuery;

  const sizeItemTablet = `w-1/${itemsPerRowPerMediaQuery.tablet}`;
  const sizeItemDesktop = `w-1/${itemsPerRowPerMediaQuery.desktop}`;
  const sizeItemMobile = mobile === 1 ? 'w-full' : 'w-1/2';

  return (
    <div className={`launcherItem w-full tablet:${sizeItemTablet} desktop:${sizeItemDesktop} mobile:${sizeItemMobile} p-8px sm:p-4px`}>
      <Link to={url} localizationpath={path} className="text-black">
        <div className="mb-14 sm:mb-6 md:mb-10 launcherItemImg relative" key={url}>
          <img className="mb-5 min-w-full" src={imageModifier(translateObj(image, language), IMAGE_SIZE)} alt={translateObj(title, language)} />
          <p className="my-2 font-americaRegular text-xxs text-white uppercase" style={{ color }}>{tag}</p>
          <h2 className="font-americaRegular text-lg tracking-0025 text-white" style={{ color }}>{translateObj(title, language)}</h2>
        </div>
      </Link>
    </div>
  );
};

News.propTypes = {
  image: PropTypes.shape({
    en: PropTypes.string,
  }).isRequired,
  title: PropTypes.shape().isRequired,
  tags: PropTypes.arrayOf(PropTypes.string),
  url: PropTypes.string,
  itemsPerRowPerMediaQuery: PropTypes.shape(DEFAULT_PROPS_ITEMS_PER_ROW),
  color: PropTypes.string,
};

News.defaultProps = {
  tags: [],
  url: null,
  itemsPerRowPerMediaQuery: DEFAULT_PROPS_ITEMS_PER_ROW,
  color: 'transparent',
};

export default News;
